import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { LinkedService } from './linkedservice';
import { IAttribute, IModel } from '../base/annotation';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { AzureKeyVault } from './key-vault';
import { shellStringResources, Credential, IViolation, sharePointOnlineAuthTypes, servicePrincipalCredentialTypes } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.sharePointOnlineList.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SharePointOnlineList_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SharePointOnlineList_DisplayText)
    ]
})
export class SharePointOnlineListLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static readonly SITE_URL: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly TENANTID_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_SiteUrl,
        association: 'SITE_URL',
        templatable: true
    })
    public siteUrl: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANTID_ID',
        templatable: true
    })
    public tenantId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalCredentialType
    })
    public servicePrincipalCredentialType?: keyof typeof servicePrincipalCredentialTypes = 'ServicePrincipalCert';

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCert,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCert?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCertPassword,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCertPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: SharePointOnlineListLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public isOldServicePrincipalResource: boolean = false;

    public isExistingServicePrincipalKeyResource: boolean = false;

    private static validateCredential(linkedservice: SharePointOnlineListLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice && linkedservice.authenticationType === sharePointOnlineAuthTypes.UserAuth && !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
